import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const CollectionCentersList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getCollectionCenters } = useHttp();

  const getCollectionCenterData = () => {
    getCollectionCenters(
      {
        url:`/api/collectionCenter/?orgId=${localStorage.getItem("orgId")}`
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getCollectionCenterData();
  }, [getCollectionCenters]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, Id) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Collection Center detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/collectionCenter/?orgId=${localStorage.getItem(
              "orgId"
            )}&createdBy=${parseInt(
              localStorage.getItem("id")
            )}&collectionCenterId=${Id}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getCollectionCenterData();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.name.toLowerCase().includes(filetrtext) ||
        item.code.toLowerCase().includes(filetrtext) ||
        item.city.toLowerCase().includes(filetrtext) ||
        item.employeeName.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
    //  height: "80%",
      minHeight: "300px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    setSelectedData(data);

    setIsModalOpen(true);
  };
 const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);


  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Collection Center Details{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.sId(serviceId || 0);
                props.update(false);
              }}
            >
              Add Collection Center
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Collection Center Name </th>
                            <th>Collection Center Code </th>
                            <th>City </th>
                            <th>Employee Name </th>
                            <th>Status</th>
                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.name}</td>

                                <td>{x.code}</td>

                                <td>{x.city}</td>

                                <td>{x.employeeName}</td>

                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => handleDelete(e, x.id)}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Collection Center Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Collection Center Code: {selectedData.code}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Collection Center Name: {selectedData.name}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Assigned Employee: {selectedData.employeeName}
              </p>
              <p className="col-md-6">Warehouse : {selectedData.warehouseName}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Collection Center Address : {selectedData.address}
              </p>
              <p className="col-md-6">City: {selectedData.city}</p>

            
           
            </div>
            <div className="row">
                <p className="col-md-6">State : {selectedData.state}</p>
                <p className="col-md-6">Country: {selectedData.country}</p>
              </div>
            <div className="row">
              <p className="col-md-6">Zip Code: {selectedData.zipCode}</p>
              <p className="col-md-6">
                Contact Number(Work): {selectedData.contactWork}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Contact Number(whatsapp): {selectedData.whatsapp}
              </p>
              <p className="col-md-6">Email Id : {selectedData.emailId}</p>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default CollectionCentersList;
